import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { goBack, setModal } from 'slices/modal'
import { MODAL_CUSTOM_CLASS, MODAL_KEYS } from 'app-constants'
import { STATICS } from 'statics'
import { Card } from 'components/card'
import { ModalTemplate } from './templates'
import './style.scss'

export function Modal() {
  const [isOpen, setIsOpen] = useState(false)
  const { key, locked, history, onClose } = useSelector(({ modal }) => modal)
  const dispatch = useDispatch()

  useEffect(() => {
    setIsOpen(!!key)
  }, [key])

  const handleClose = useCallback(() => {
    if (!locked) {
      dispatch(setModal({ key: MODAL_KEYS.NONE }))
      if (onClose) onClose()
    }
  }, [dispatch, locked, onClose])

  const handleReturn = useCallback(() => {
    dispatch(goBack())
  }, [dispatch])

  function getCardClass() {
    const customClass = MODAL_CUSTOM_CLASS[key]

    return `card ${customClass || ''}`
  }

  function renderBackButton() {
    return <STATICS.ARROW_BACK className='icon back' onClick={handleReturn} />
  }

  const renderContent = () => (
    <div className={`modal-component ${isOpen ? '-open' : ''}`}>
      <Card className={getCardClass()}>
        {history.length > 0 && renderBackButton()}
        {!locked && <STATICS.CLOSE_WITH_BOX className='icon close' onClick={handleClose} />}
        <div className='modal-content'>{ModalTemplate()[key]}</div>
      </Card>
      <div className='overlay' onClick={handleClose} />
    </div>
  )

  return renderContent()
}
